import styled from 'styled-components'
import { fromDesktop } from 'utilities/styled'
import { Grid } from 'components/grid'

export const Wrap = styled(Grid)`
    display: grid;
    grid-template-columns:
        [wrap-start bulk] 24px
        [name] minmax(0, 2fr)
        [editable1] minmax(0, 1fr)
        [editable2] minmax(0, 1fr)
        [actions] 40px [wrap-end];
    column-gap: 24px;

    &.slim {
        grid-template-columns: unset;
    }

    &:empty { display: none; }

    ${fromDesktop`
        margin-inline-start: -48px;
        width: calc(100% + 48px);

        &.slim {
            margin-inline-start: 0;
            width: 100%;
        }
    `}
`

export const LoadingContainer = styled.div`
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    height: 96px;
`